'use client';
import { WEB_RED_REG } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const StyledBadge = styled.div`
  color: ${WEB_RED_REG};
  font-size: 1rem;
  font-weight: 500;
  line-height: 120%;
`;

type Props = {
  text: string | null | undefined;
};

const Badge = ({ text }: Props) => {
  if (!text) return null;
  return <StyledBadge>{text}</StyledBadge>;
};

export default Badge;
